import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["small"];
import * as stylex from '@stylexjs/stylex';
import { Small } from 'foundations-components/transitional/components/Small';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { BodyText } from 'trellis-components/components/BodyText';
import { Text } from 'trellis-components/components/Text';
import { useUiVariant } from './UiVariantProvider';
import { toMarginXstyle } from './utils/foundationsSpacing';
import { jsx as _jsx } from "react/jsx-runtime";
const _temp = {
  maxWidth: "x13i5qev",
  "$$css": true
};
const styles = {
  wrapper: {
    display: "x78zum5",
    minWidth: "xeuugli",
    $$css: true
  },
  maxWidth: maxWidth => [_temp, {
    "--x-maxInlineSize": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(maxWidth)
  }]
};
const TrellisTruncateString = ({
  children,
  marginInlineStart,
  maxWidth,
  small
}) => {
  const text = small ? /*#__PURE__*/_jsx(BodyText, {
    size: "sm",
    strong: small.weight !== undefined,
    truncated: true,
    children: children
  }) : /*#__PURE__*/_jsx(Text, {
    truncated: true,
    children: children
  });
  if (marginInlineStart === undefined && maxWidth === undefined) {
    return text;
  }
  return /*#__PURE__*/_jsx("span", Object.assign({}, stylex.props(styles.wrapper, maxWidth !== undefined && styles.maxWidth(maxWidth), toMarginXstyle({
    marginInlineStart
  })), {
    children: text
  }));
};
export const CdpTruncateString = _ref => {
  let {
      small
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const variant = useUiVariant();
  if (variant === 'trellis') {
    return /*#__PURE__*/_jsx(TrellisTruncateString, Object.assign({
      small: small
    }, props));
  }
  return /*#__PURE__*/_jsx(TruncateString, Object.assign({}, props, {
    children: small ? /*#__PURE__*/_jsx(Small, Object.assign({}, small, {
      children: props.children
    })) : props.children
  }));
};